export const appLinkClickHandler = (appLink: string, target: string) => {
    window.open(appLink);
};
